import { apiClient } from './client.tsx';
import type {
  CreatePartnerStaffRequest,
  UpdatePartnerStaffRequest,
} from './requests/partner-staff-request.ts';

type UpdateRequestWithoutId = Omit<UpdatePartnerStaffRequest, 'id'>;

export const fetchPartnerStaffs = (partnerId: string) =>
  apiClient
    .get(`/v2/partner_staffs?partnerId=${partnerId}`)
    .then((res) => res.data.data);

export const fetchPartnerStaff = (id: string) =>
  apiClient.get(`/v2/partner_staffs/${id}`).then((res) => res.data.data);

export const createPartnerStaff = (request: CreatePartnerStaffRequest) =>
  apiClient.post(`/v2/partner_staffs`, request).then((res) => res.data.data);

export const updatePartnerStaff = (request: UpdatePartnerStaffRequest) =>
  apiClient
    .put(`/v2/partner_staffs/${request.id}`, <UpdateRequestWithoutId>request)
    .then((res) => res.data);

export const voidPartnerStaff = (id: string) =>
  apiClient.delete(`/v2/partner_staffs/${id}`).then((res) => res.data);
